import { render } from "./notification-content.vue?vue&type=template&id=e5b2d316&scoped=true"
import script from "./notification-content.vue?vue&type=script&lang=js"
export * from "./notification-content.vue?vue&type=script&lang=js"

import "./notification-content.vue?vue&type=style&index=0&id=e5b2d316&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b2d316"]])

export default __exports__